import { render, staticRenderFns } from "./PreviewCustomization.vue?vue&type=template&id=793ff6bd&scoped=true&"
import script from "./PreviewCustomization.vue?vue&type=script&lang=js&"
export * from "./PreviewCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ff6bd",
  null
  
)

export default component.exports